import { Injectable, EventEmitter } from "@angular/core";

/**
 * @whatItDoes A service for holds all the emitting events and retrns them back on request.
 *
 * @howToUse Inject the service
 */
@Injectable()
export class EmitterService {
    private static _emitters: { [key: string]: EventEmitter<any> } = {};

    /**
     * @whatItDoes The get method will return the requested emitter event if it is available or create a new one.
     *
     * @howToUse Inject the service
     */
    static get(key: string): EventEmitter<any> {
        if (!this._emitters[key]) {
            this._emitters[key] = new EventEmitter();
        }
        return this._emitters[key];
    }
}